const tokenPath = "/asset/token/";
export const TOKEN_LOGOS = {
    // Token Icons
    TOKEN_FALLBACK: tokenPath + "_fallback.svg",
    TOKEN_USDC: tokenPath + "usdc-icon.svg",
    TOKEN_IUSD: tokenPath + "iusd-icon.svg",
    TOKEN_SIUSD: tokenPath + "siusd.svg",
    TOKEN_LIUSD: tokenPath + "liusd.svg",
    TOKEN_TETHER: tokenPath + "tether.webp",
    TOKEN_SUSDE: tokenPath + "susde.svg",
    TOKEN_USDE: tokenPath + "usde.svg",

    // Pendle PT Token Icons
    TOKEN_SLVLUSD: tokenPath + "slvlusd.svg",
    TOKEN_SYRUPUSDC: tokenPath + "syrupusdc.svg",
    TOKEN_USR: tokenPath + "usr.svg",
    TOKEN_TUSDE: tokenPath + "tusde.svg",
    TOKEN_PUSDE: tokenPath + "pusde.svg",
    TOKEN_WSRUSD: tokenPath + "wsrusd.svg",
};
